import { getEnvironment } from './utils';

const {
  OP_USER_GAME_IMAGES,
  OP_USER_WIDE_GAME_IMAGES,
  OP_DEFAULT_GAME_IMAGES,
} = getEnvironment();

export const gameImagePublicId = (url, type) => {
  if (!url) return;

  const wideRegex = new RegExp(OP_USER_WIDE_GAME_IMAGES);
  const regex = new RegExp(OP_USER_GAME_IMAGES);

  if (url.match(OP_DEFAULT_GAME_IMAGES)) {
    return url.replace(OP_DEFAULT_GAME_IMAGES, `${type}/game_defaults/`);
  } else if (url.match(wideRegex)) {
    return url.replace(wideRegex, `${type}-$1/game/wide/`);
  }

  return url.replace(regex, `${type}-$1/game/`);
};

/**
 * Each wb-admin instance has a default Cloudinary cloud name set in its context.
 * However, some game templates have images from a different Waybetter cloud name
 * (e.g. staging vs. prod), so we need to parse it out and override the instance's
 * default.
 *
 * @constant
 */
const CLOUD_NAME_REGEX = /cloudinary.com\/([^/]+)\/image\//;

/**
 * Pluck the cloud name from a given cloudinary image URL.
 *
 * @exports
 * @param {string} url - Cloudinary image URL.
 * @returns {string} Cloudinary cloud name.
 */
export const parseCloudName = (url) => {
  if (!url) {
    return null;
  }
  const [, cloudName] = CLOUD_NAME_REGEX.exec(url) || [];
  return cloudName;
};
